import { IColumn } from '@fluentui/react/lib/components/DetailsList';

export enum MemberType {
  Unassigned = 'Unassigned',
  Guest = 'Guest',
  FAM = 'Full Access Member',
  OrganisationAdmin = 'Organisation Admin',
  StateGuest = 'State Guest',
  StateLicensedAccount = 'State Licensed Account',
  LinkedGuestUser = 'Linked Guest User',
  Sponsored = 'Sponsored',
  LAM = 'Limited Access Member',
  Partner = 'Partner',
}

export enum CommunityType {
  Open = 1,
  Private = 2,
  Hidden = 3
}

export enum CommunityRole {
  Owner = 'Owner',
  Member = 'Member'
}

export enum MemberStatus {
  VerificationPending = 'Verification Pending',
  Active = 'Active',
  UnderReview = 'Under Review',
  Inactive = 'Inactive',
  Suspended = 'Suspended',
  Blocked = 'Blocked',
  PendingLicence = 'Pending Licence',
  PendingLicenceRemoval = 'Pending Licence Removal',
  PendingDeactivation = 'Pending Deactivation',
  PendingLicenceAssignment = 'Pending Licence Assignment',
  ApprovalPending = 'Approval Pending',
  ApprovalDeclined = 'Approval Declined'
}

export interface ICommunityMember {
  accountType: string;
  azureId: string;
  department: string;
  emailAddress: string;
  fullName: string;
  inactiveDays: number;
  isGuest: boolean;
  linkedAzureId: string | null;
  memberStatus: MemberStatus;
  memberType: MemberType;
  occupation: string;
  role: CommunityRole;
}

interface ICommunityMembersState {
  searchWord: string;
  searchCleared: boolean;
  filteredItems: ICommunityMember[];
  isFilterOpen: boolean;
  filtersCleared: boolean;
  selectedMemberTypes: string[];
  selectedStatuses: string[];
  selectedCommunityRoles: string[];
  columns: IColumn[];
  hasUpdated: boolean;
}